import { Box, styled } from '@mui/material';

export const PDFPageSelectionControlsContainer = styled(Box)<{ $allowPageSelection: boolean }>(
  ({ $allowPageSelection }) => ({
    borderBottom: '1px solid #e0e0e0',
    backgroundColor: 'white',
    display: 'flex',
    alignItems: 'center',
    gap: 2,
    flexWrap: 'wrap',
    position: $allowPageSelection ? 'sticky' : 'relative',
    top: $allowPageSelection ? 0 : undefined,
    zIndex: $allowPageSelection ? 10000 : undefined,
  })
);
